<template>
    <v-card :loading="loading">
        <div class="d-flex justify-end">
            <bread-crumbs :items="breadItems"></bread-crumbs>
        </div>
        <v-form @submit.prevent="save">
            <v-container>
                <fieldset>
                    <v-row>
                        <v-col cols="12" xs="12"></v-col>
                        <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">Role Name</label>
                            <v-text-field v-model="data.role_name" :error-messages="roleNameError" label="Role Name"
                                placeholder="Role Name" solo></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn :loading="loading" color="primary" @click="save">Save</v-btn>
                        </v-col>
                    </v-row>
                </fieldset>
            </v-container>
        </v-form>
    </v-card>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import BreadCrumbs from '../../../components/BreadCrumbs.vue';

export default {
    mixins: [validationMixin],
    validations: {
        role_name: { required },
    },

    name: "AddRole",
    components: { BreadCrumbs },

    data() {
        return {
            loading: true,
            data: { role_name: "" },
            breadItems: [
                {
                    text: "Dashboard",
                    disabled: false,
                    href: "/",
                    to: {
                        name: "DashBoard"
                    }
                },
                {
                    text: "Settings",
                    disabled: false,
                    to: {
                        name: "Settings"
                    }
                },
                {
                    text: this.$route.meta.title,
                    disabled: true,
                    to: {
                        name: this.$route.name
                    }
                }
            ]
        };
    },

    computed: {
        roleNameError() {
            const errors = []
            if (!this.$v.role_name.$dirty) return errors
            !this.$v.role_name.required && errors.push('Role Name is required.')
            return errors
        },
    },

    methods: {
        save() {
            if (this.$route.params.id) {
                this.update();
            } else {
                this.create();
            }
        },
        update() {
            if (this.data.role_name) {
                this.loading = true;
                axios
                    .post(apiRoutes.roles.updateRole + "/" + this.$route.params.id, {
                        role: this.data.role_name
                    })
                    .then((response) => {
                        this.loading = false;
                        this.$v.$reset()
                        this.data.role_name = ''
                        this.$router.replace({ name: "Roles" });
                    })
                    .catch((response) => {
                        if (response.status === 400) {
                            this.errors = response.data;
                        }
                        if (response.status === 422) {
                            this.errors = response.data.errors;
                        }
                        this.loading = false;
                    });
            } else {
                this.$v.$touch()
            }
        },
        create() {
            if (this.data.role_name) {
                this.loading = true;
                axios
                    .post(apiRoutes.roles.addRoles, { role: this.data.role_name })
                    .then((response) => {
                        this.loading = false;
                        this.$v.$reset()
                        this.data.role_name = ''
                        this.$router.replace({ name: "Roles" });
                    })
                    .catch((response) => {
                        if (response.status === 400) {
                            this.errors = response.data;
                        }
                        if (response.status === 422) {
                            this.errors = response.data.errors;
                        }
                        this.loading = false;
                    });
            } else {
                this.$v.$touch()
            }
        }
    },
    created() {
        this.loading = false;
        if (this.$route.params.id) {
            this.loading = true;
            axios
                .get(apiRoutes.roles.getRoleById + '/' + this.$route.params.id)
                .then(res => {
                    this.data.role_name = res.data.response.display_name
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    console.log(err, 'err');
                })
        }
    },
};
</script>

<style lang="scss" scoped>
fieldset {
    border: 0;

    & label {
        font: Bold 15px/40px Lato;
        color: #172b4d;
    }
}
</style>

